import React from 'react';
import { Box } from '@mui/material';
import { COLORS, LINE_ALPHA } from '../../theme';

export const Sparkle = ({ size = 40, color = COLORS.dark, sx = {} }) => (
  <Box
    component="svg"
    viewBox="0 0 40 40"
    sx={{ width: size, height: size, display: 'block', ...sx }}
  >
    <path
      d="M20 2 C20.8 10 22.5 17.5 20 20 C22.5 22.5 20.8 30 20 38 C19.2 30 17.5 22.5 20 20 C17.5 17.5 19.2 10 20 2Z"
      fill={color}
    />
    <path
      d="M2 20 C10 19.2 17.5 17.5 20 20 C17.5 22.5 10 20.8 2 20Z M38 20 C30 20.8 22.5 22.5 20 20 C22.5 17.5 30 19.2 38 20Z"
      fill={color}
    />
  </Box>
);

export const Diamond = ({ size = 12, color = COLORS.orange, sx = {} }) => (
  <Box sx={{ width: size, height: size, bgcolor: color, transform: 'rotate(45deg)', ...sx }} />
);

export const Ring = ({ size = 20, color = COLORS.dark, sx = {} }) => (
  <Box
    sx={{ width: size, height: size, borderRadius: '50%', border: `2px solid ${color}`, ...sx }}
  />
);

export const GridOverlay = ({ dark = false }) => {
  const linha = dark ? 'rgba(255,255,255,0.05)' : `rgba(28,27,25,${LINE_ALPHA.grid})`;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        backgroundImage: `linear-gradient(${linha} 1px, transparent 1px), linear-gradient(90deg, ${linha} 1px, transparent 1px)`,
        backgroundSize: '64px 64px',
        zIndex: 0,
      }}
    />
  );
};
